<script setup>
import { computed } from 'vue';
import Modal from '@maison/components/common/Modal.vue';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

const props = defineProps({
  localisations: {
    type: Array,
    required: true,
  },
  countries: {
    type: Object,
    required: true,
  },
});

const currentLocalisation = computed(() => {
  return props.localisations.find(
    (localisation) =>
      localisation.url_code === window.Phoenix.localisationUrlCode &&
      localisation.country_code === window.Phoenix.currentCountry,
  );
});
</script>

<template>
  <modal id="country-proposition-banner">
    <template #content>
      <div class="rich-text">
        <h2 class="heading-large mb-6">{{ $t('CountryProposition.title', { label: currentLocalisation.label }) }}</h2>
        <p>
          {{
            $t('CountryProposition.text1', {
              labelWithLanguage: currentLocalisation.select_label,
              label: currentLocalisation.label,
            })
          }}
        </p>
        <p>{{ $t('CountryProposition.text2') }}</p>
      </div>

      <div class="flex flex-col gap-2 mt-6">
        <a
          v-for="localisation in localisations"
          :key="localisation.select_label"
          :href="localisation.url"
          :data-code="localisation.country_code"
          class="btn btn--primary btn--plain country-proposition-item hidden"
        >
          <span class="btn__text">{{ localisation.select_label }}</span>
        </a>

        <PhxsgButton variant="fade" data-modal-close="country-proposition-banner" class="pt-2">
          {{ $t('CountryProposition.stayOnCurrentSite') }}
        </PhxsgButton>
      </div>
    </template>
  </modal>
</template>
